import { DateTime } from "luxon";
import { useDataStampQuery } from "@/hooks/useDataStamp";

// Global MAX(_source_modified_dttm) across the whole fact table — independent of
// the selected period, so "Last updated" always reflects the freshest data.
//
// Shares one query with useDataStamp: the same 45-byte response carries both the
// date shown in the sidebar and the stamp the data queries key on. One request,
// two readers.
//
// The two are not interchangeable. This date is the freshest timestamp in the
// SOURCE data, so re-pulling the same Fabric snapshot leaves it unchanged even
// though the stored rows changed -- which is precisely what a rebuild does when it
// applies a write-side filter the previous pull did not have. Staleness detection
// needs the stamp, not this.
export function useLastUpdated(): DateTime | null {
  const { data } = useDataStampQuery();
  if (!data?.lastUpdated) return null;
  const dt = DateTime.fromISO(data.lastUpdated.replace(" ", "T"));
  return dt.isValid ? dt : null;
}
